<template>
    <div>
        <b-card class="standardpage reports">
            <b-card-header>
                <b-row>
                    <b-col cols="12" md="3" class="text-sm-left pt-1">
                        <i :class="slstatements.icon" class="mr-1"></i>
                        <span>{{ slstatements.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-if="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Statement Date" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker class="w-auto" size="sm" ref="datestatement"
                                            v-model="datestatement" :opens="'right'" :locale-data="locale_data"
                                            :ranges="false" :showDropdowns="true" :linkedCalendars="true"
                                            :single-date-picker="'true'">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="datestatement = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>

                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Account Type" label-size="sm">
                                    <treeselect placeholder="Select type..." v-model="accounttype" :clearable="true"
                                        :multiple="true" :options="accounttype_options" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Statement Type" label-cols="12" label-size="sm">
                                    <treeselect v-model="statementtype" :clearable="true" :multiple="true"
                                        :options="statementtype_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Status" label-size="sm">
                                    <treeselect v-model="status" :clearable="true" :options="status_options">
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="slaclike-tooltip">Group</span>
                                        <b-form-checkbox id="slacgroup" v-model="slacgroup_visible" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group v-if="!slacgroup_visible">
                                        <treeselect placeholder="Select slac..."
                                            searchPromptText="Type at least 3 chars..." v-model="slac" :clearable="true"
                                            :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :disabled="readonly">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-input-group>
                                </b-form-group>
                                <b-input-group v-if="slacgroup_visible">
                                    <b-form-group label-cols="12" label-size="sm">
                                        <treeselect v-model="slacgroup" :clearable="true" :options="slacgroup_options">
                                        </treeselect>
                                    </b-form-group>
                                </b-input-group>

                            </b-col>
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                                        v-model="slac" :multiple="true" :clearable="true" :async="true"
                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col> -->
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Transaction Dates" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="transactiondate" v-model="transactiondate"
                                            :opens="'right'" :locale-data="locale_data" :ranges="locale_ranges"
                                            :showDropdowns="true" :linkedCalendars="true" :single-date-picker="'range'">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="transactiondate = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Statement from" label-size="sm">
                                    <treeselect v-model="source" :options="source_options" :clearable="false">
                                    </treeselect>
                                </b-form-group>
                                <b-tooltip target="database" triggers="hover">The active datasource</b-tooltip>
                            </b-col> 
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Query" label-size="sm">
                                    <treeselect v-model="query" :clearable="false" :options="query_options">
                                    </treeselect>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card-body>
                </b-card>
                <!-- {{ slstatements.page }} -->
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="slstatements"
                        :selectall="slstatements.selectall" :icon="slstatements.icon" :busy="slstatements.busy"
                        :toolbarlibrary="slstatements.toolbarlibrary" :tools="slstatements.tools"
                        :badges="slstatements.badges" :fields="slstatements.fields" :items="slstatements.items"
                        :downloaded="slstatements.downloaded" :limit="slstatements.limit" :page="slstatements.page"
                        :showpages="slstatements.showpages" @load="slstatements_load" @click="slstatements_click"
                        @select="slstatements_select">
                    </d-table>
                </div>
            </div>

            <div v-if="component">
                <component :is="component" :selection="slstatements.selected" :config="cconfig"
                    @discard="slstatements_click('discard')" @refresh="slstatements_click('refresh')"></component>
            </div>

        </b-card>

    </div>
</template>


<script>
import gql from "graphql-tag";

import SLStatementEmail from "./Components/SLStatementEmail";
import SLStatementView from "./Components/SLStatementView";

export default {
    name: "SLStatements",
    components: {
        SLStatementEmail,
        SLStatementView
    },
    async mounted() {

        try {
            const response = await this.$apollo.query({
                query: gql`
            query clientaccounttypes {
              clientaccounttypes {
                id
                label: name
              }
            }
          `,
            });
            this.accounttype_options = [...response.data.clientaccounttypes];
            for (var j = 0; j < this.accounttype_options.length; ++j) {
                if (!this.accounttype_options[j].label.includes("|")) {
                    this.accounttype_options[j].label =
                        this.accounttype_options[j].label +
                        " | " +
                        this.accounttype_options[j].id;
                }
            }
        } catch (error) {
            console.log(error);
        }

        try {
            const response = await this.$apollo.query({
                query: gql`
            query statementtypes {
              statementtypes {
                id
                label
              }
            }
          `,
            });
            this.statementtype_options = [];
            this.statementtype_options = response.data.statementtypes;
        } catch (error) {
            console.log(error);
        }

        this.source_options = [{ id: "saracs_live", label: "saracs_live" }];
        for (var k = 1; k < 13; k++) {
            this.source_options.push({
                id: this.$moment().subtract(k, "months").format("YYYYMM"),
                label: this.$moment().subtract(k, "months").format("YYYYMM"),
            });
        }

        try {
            const response = await this.$apollo.query({
                query: gql`
                    query setup_clientgroups {
                        setup_clientgroups {
                            id: code
                            label
                            slac
                        }
                    }
                `,
            });
            this.slacgroup_options = response.data.setup_clientgroups;
        } catch (error) {
            console.log(error);
        }

        // // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
        // if (this.slstatements.actions) {
        //     if (this.slstatements.fields.some((e) => e.key === "actions")) {
        //     } else {
        //         this.slstatements.fields.push({
        //             key: "actions",
        //             label: "",
        //             class: "actions w-140px",
        //         });
        //     }
        // }
    },

    watch: {

        async datestatement() {
            await this.slstatements_load(0);
        },
        async transactiondate() {
            await this.slstatements_load(0);
        },

        async source() {
            if (this.source == "saracs_live") {
                this.datestatement = this.$moment().format("YYYY-MM-DD");
            } else {
                this.datestatement = this.$moment(this.source + "01", "YYYYMMDD")
                    .endOf("month")
                    .format("YYYY-MM-DD");
            }
            await this.slstatements_load(0);
        },
        async statementtype() {
            await this.slstatements_load(0);
        },
        async accounttype() {
            await this.slstatements_load(0);
        },
        async slac() {
            await this.slstatements_load(0);
        },
        async slacgroup() {
            if (this.slacgroup && this.slacgroup.length > 0) {
                let slgroup = this.slacgroup_options.find((o) => o.id == this.slacgroup).slac;
                if (slgroup) {
                    this.slac = slgroup.split(",");
                } else {
                    this.slac = []
                }
                console.log(this.slac)
            } else {
                this.slac = [];
            }
        },
        async datestatement() {
            await this.slstatements_load(0);
        },
        async status() {
            await this.slstatements_load(0);
        },
        async query() {
            await this.slstatements_load(0);
        },
    },
    data() {
        return {
            busy: false,
            id: null,
            query: null,
            datestatement: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            transactiondate: {
                startDate: null,
                endDate: null,
            },
            slac: null,
            slacgroup: null,
            slacgroup_visible: false,
            slacgroup_options: [],
            source: "saracs_live",
            statementtype: ["E"],
            status: "",
            statementtype_options: null,
            accounttype: [],
            accounttype_options: [],
            source_options: [{ id: "saracs_live", label: "saracs_live" }],
            status_options: [
                { id: "", label: "All" },
                { id: "due", label: "Due" },
                { id: "credit", label: "Credit" },
            ],
            query: "outstanding",
            query_options: [
                { id: "outstanding", label: "Outstanding" },
                { id: "invoiceonly", label: "Invoice Only" },
                { id: "creditonly", label: "Credit Only" },
            ],
            balance: 0,
            slstatements: {
                title: "Statements",
                icon: "fa fa-list-alt",
                selectall: false,
                debounce: 500,
                busy: false,
                showpages: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,view,email",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-envelope-o text-warning",
                        position: "toolbar,actions",
                        action: "email",
                        label: "Email",
                        component: {
                            name: "SLStatementEmail",
                        },
                    },
                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                    },
                    {
                        key: "to",
                        label: "To",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "datelast",
                        label: "Date Recent",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "outstanding",
                        label: "Outstanding",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        // type: "Int",
                        total: 0,
                    },
                    {
                        key: "credit",
                        label: "Type",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-140px",
                    },
                ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "primary",
                        Debit: "danger",
                        formatter: (value, key, item) => {
                            if (parseFloat(value) < 0) {
                                return "Credit";
                            } else {
                                return "Debit";
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    computed: {

        readonly() {
            if (this.user.permissions.includes('salesledger.admin')) {
                return false;
            }
            return true;
        },
    },
    methods: {
        async slstatements_load(offset, limit, page) {

            let state = this.slstatements;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;


            // if (page) {
            //     this.slstatements.page = page
            // }

            // if (limit != 0) { this.slstatements.items = []; }
            // this.slstatements.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                datestatement: this.datestatement.startDate,
                trans_at: this.transactiondate.startDate ? [this.transactiondate.startDate, this.transactiondate.endDate] : null,
                source: this.source,
                statementtype: this.statementtype ? this.statementtype.join(",") : null,
                accounttype: this.accounttype.length > 0 ? this.accounttype.join(",") : null,
                slac: this.slac ? this.slac.join(",") : null,
                status: this.status,
                query: this.query ? this.query : null,
            };
            try {
                const response = await this.$apollo.query({
                    query: gql`
              query statements(
                $offset: Int
                $limit: Int
                $source: String
                $statementtype: String
                $accounttype: String
                $datestatement: String
                $slac: String
                $status: String
                $trans_at: [String]
                $query: String
              ) {
                statements(
                  offset: $offset
                  limit: $limit
                  source: $source
                    statementtype: $statementtype
                    accounttype: $accounttype
                    datestatement: $datestatement
                    slac: $slac
                    status: $status
                    trans_at: $trans_at
                    query: $query
                ) {
                    id
                    slac
                    to
                    outstanding
                    credit:outstanding
                    datelast
                    rows
                }
              }
            `,
                    variables,
                });

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.statements
                } else {
                    state.items = response.data.statements;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },

        async slstatements_click(a, ss) {
            console.log("slstatements_click", a, ss);

            let state = this.statements;

            switch (a) {

                case "selectall":
                    // await this.slstatements_load(0, 0);
                    break;

                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.slstatements_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;

                case "discard":
                    this.component = null;
                    break;

                case "go":
                    this.component = null;
                    this.slstatements_load();
                    break;

                case "email":
                    this.component = "SLStatementEmail";
                    break;

                case "view":
                    this.component = "SLStatementView";
                    break;

            }
        },

        async slstatements_select(ss, tools) {

            let state = this.slstatements;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "download"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["view", "email"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["email"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
    },
};
</script>

<style></style>